import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ACCOUNTS_ACTIONS } from '../actions/accounts.actions';
import { AccountsService } from '../../services/accounts.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AccountsEffects {
  constructor(
    private readonly actions: Actions,
    private readonly accountsService: AccountsService,
  ) {}

  getAccounts$ = createEffect(() =>
    this.actions.pipe(
      ofType(ACCOUNTS_ACTIONS.getAccounts),
      switchMap(() =>
        this.accountsService.getAccounts().pipe(
          map((accounts) => ACCOUNTS_ACTIONS.getAccountsSuccess(accounts)),
          catchError((err: HttpErrorResponse) => of(ACCOUNTS_ACTIONS.getAccountsError(err))),
        ),
      ),
    ),
  );
}
